module.exports = __webpack_public_path__ + "static/media/blankPrize.f7837d86.png";